// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
//import the vue instance
import Vue from "vue";
//import the App component
import App from "./App";

//import the vue router
import VueRouter from "vue-router";
import VueResource from "vue-resource";
import vueSmoothScroll from "vue-smooth-scroll";
import VueParallaxJs from "vue-parallax-js";
import VueAnalytics from "vue-analytics";
import vueHeadful from "vue-headful";

// Components
import Home from "./components/Home";
import Equipo from "./components/Institucional/Equipo";
import Estandares from "./components/Institucional/Estandares";
import Trayectoria from "./components/Institucional/Trayectoria";
import Novedades from "./components/Novedades";
import Coberturas from "./components/Coberturas/Coberturas";
import ServicioEstudios from "./components/Servicios/Estudios";
import ServicioDudas from "./components/Servicios/Dudas";
import ServicioPreguntas from "./components/Servicios/Preguntas";
import ServicioExtracciones from "./components/Servicios/Extracciones";
import NotFound from "./components/NotFound";
import * as VueGoogleMaps from "vue2-google-maps";
import jQuery from "jquery";
global.JQuery = jQuery;

require("../static/vendor/bootstrap/dist/css/bootstrap.min.css");
require("../static/vendor/bootstrap/dist/js/bootstrap.min.js");
require("../static/vendor/font-awesome/css/font-awesome.min.css");
require("../static/scss/app.css");

//tell vue to use the router
Vue.use(VueResource);
Vue.use(VueRouter);
Vue.use(vueSmoothScroll);
Vue.use(VueParallaxJs);
Vue.use(VueGoogleMaps, {
  load: {
    key: "AIzaSyD-aeOV2bIVfzy2Vyh_FtrGkKmgMSfXv2A",
    libraries: "places", // This is required if you use the Autocomplete plugin
    // OR: libraries: 'places,drawing'
    // OR: libraries: 'places,drawing,visualization'
    // (as you require)
  },
});

Vue.component("vue-headful", vueHeadful);

//define your routes
const routes = [
  //define the root url of the application.
  { path: "/", component: Home },
  { path: "/institucional/nuestro-equipo", component: Equipo },
  { path: "/institucional/estandares", component: Estandares },
  { path: "/institucional/trayectoria", component: Trayectoria },
  {
    path: "/novedades",
    component: Novedades,
    meta: { title: "Novedades Varelab" },
  },
  { path: "/coberturas", component: Coberturas },
  { path: "/servicios/estudios", component: ServicioEstudios },
  { path: "/servicios/dudas", component: ServicioDudas },
  { path: "/servicios/preguntas", component: ServicioPreguntas },
  { path: "/servicios/extracciones", component: ServicioExtracciones },
  { path: "*", component: NotFound },
  // { path: '/about', component: About },
];

// Create the router instance and pass the `routes` option
// You can pass in additional options here, but let's
// keep it simple for now.
const router = new VueRouter({
  routes, // short for routes: routes
  mode: "history",
  // base: __dirname,
  base: "/",
  linkExactActiveClass: "active",
  scrollBehavior: function (to, from, savedPosition) {
    const position = {};
    if (to.hash) {
      position.selector = to.hash;

      // bypass #1number check
      if (/^#\d/.test(to.hash) || document.querySelector(to.hash)) {
        return position;
      }

      // if the returned position is falsy or an empty object,
      // will retain current scroll position.
      return false;
    } else {
      return { x: 0, y: 0 };
    }
  },
});

Vue.use(VueAnalytics, {
  id: ["UA-114873808-1", "AW-932442130"],
  router,
});

//instatinat the vue instance
new Vue({
  //define the selector for the root component
  el: "#app",
  //pass the template to the root component
  template: "<App/>",
  //declare components that the root component can access
  components: { App },
  //pass in the router to the Vue instance
  router,
}).$mount("#app"); //mount the router on the app

Vue.http.options.root = "http://www.varelab.com.ar/api/public/api/";
// Vue.http.options.root = 'http://gema.local/varelab/api/public/api/';
// Vue.http.options.root = 'http://gematesteo.com/varelab/api/public/api/';
Vue.http.options.emulateJSON = true;



// WEBPACK FOOTER //
// ./src/main.js